import React, { useState } from 'react'
import { CustomTabView, PageHeader } from '../../../../components'
import { TabPanel } from 'primereact/tabview'
import RegrasFaturamento from './RegrasFaturamento/RegrasFaturamento'
import FaixasKm from './FaixasKm/FaixasKm'
import DiariasPorVeiculo from './DiariasPorVeiculo/DiariasPorVeiculo'

const INITIAL_STATE = {
  activeTab: 0,
}

const RegrasFrete = () => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const onTabChange = value => {
    setState(prevState => ({ ...prevState, activeTab: value }))
  }

  return (
    <div>
      <PageHeader>2.15 - Regras de Frete</PageHeader>
      <CustomTabView activeIndex={state.activeTab} onTabChange={onTabChange}>
        <TabPanel header={'Faixas de KM'}>
          <FaixasKm />
        </TabPanel>
        <TabPanel header={'Regras de Faturamento'}>
          <RegrasFaturamento />
        </TabPanel>
        <TabPanel header={'Diárias por tipo de veículo'}>
          <DiariasPorVeiculo />
        </TabPanel>
      </CustomTabView>
    </div>
  )
}

export default RegrasFrete
